export const locale = {
    lang: 'pl',
    data: {
        "Employee schedule": "Grafik pracowników",
        "New": "Nowa",
        "Name": "Nazwa",
        "Actions": "Akcje",
        "Edit": "Edycja",
        "Device group data": "Dane grupy produktów",
        "Save": "Zapisz",
        "Cancel": "Anuluj",
        "New employee schedule": "Nowy grafik pracownika",
        "Edit employee schedule": "Edycja grafika pracownika",
        "Worker": "Pracownik",
        "Add hour": "Dodaj godziny",
        "Start hour": "Godzina rozpoczęcia",
        "End hour": "Godzina zakończenia",
        "Description": "Opis",
        "Hour is required and should be in format: HH:MM": "Wymagany format to HH:MM",
        "Delete": "Usuń",
        "Confirm deletion": "Potwierdź usunięcie",
        "Confirm": "Potwierdź",
        "Are you sure you want to delete selected employee schedule?": "Czy usunąć wybrany grafik?"
    }
};
